import { Field } from 'Components/Core';
import { IFieldSpecificProps } from 'Components/Core/Field/types';
import { hasValue } from 'Lib/Any';
import { recursiveMap } from 'Lib/React';
import classNames from 'classnames';
import React from 'react';
import './FieldSet.scss';

type FieldSetProps = {
  visible?: boolean;
} & Pick<IFieldSpecificProps, 'horizontalLabelWidth'>;

/**
 * A layout wrapper for a set of Fields, to make them behave as 1 Field.
 */
const FieldSet: React.FC<React.PropsWithChildren<FieldSetProps>> = ({
  children,
  visible = true,
  horizontalLabelWidth,
}) => {
  return !visible ? null : (
    <div className={classNames('FieldSet')}>
      {hasValue(horizontalLabelWidth)
        ? recursiveMap(children, (c) => (c.type === Field ? React.cloneElement(c, { horizontalLabelWidth }) : c))
        : children}
    </div>
  );
};

export { FieldSet };
export default FieldSet;
